var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8229 3.5H10.4553V12.3551C10.4553 13.4102 9.5447 14.2768 8.41147 14.2768C7.27825 14.2768 6.36762 13.4102 6.36762 12.3551C6.36762 11.3188 7.25801 10.471 8.35077 10.4333V8.21015C5.94266 8.24782 4 10.0754 4 12.3551C4 14.6536 5.98314 16.5 8.43172 16.5C10.8803 16.5 12.8634 14.6348 12.8634 12.3551V7.81448C13.7538 8.41739 14.8465 8.77536 16 8.79421V6.57102C14.2192 6.51449 12.8229 5.15797 12.8229 3.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTiktok);
export default __webpack_public_path__ + "static/media/menu-tiktok.7b5dd681dcddf0a3add667611a83921b.svg";
export { ForwardRef as ReactComponent };